export const USER_ROLE = {
  ADMIN: 'admin',
  STAFF: 'staff',
  DOCTOR: 'doctor'
};


// WEBPACK FOOTER //
// ./src/router/constant.js